import React, { Component } from 'react';
import styled from 'styled-components';
import avatar from './avatar.jpeg';
import SOCIAL_LINKS from 'constants/social-links';
import Wallpaper from 'components/Wallpaper';

const AppContainer = styled.div`
  width: 100%;
  background: #000;
  display: flex;
  justify-content: center;
  user-select: none;
`;

const ContentContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SocialInformationContainer = styled.div`
  width: 500px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const Owner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Avatar = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  
  img {
    width: 100%;
  }
`;

const Name = styled.span`
  font-size: 24px;
  color: #ffffff;
  margin: 16px;
  line-height: 1.4;
`;

const SocialLinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 320px;
`;

const SocialLink = styled.a`
  display: flex;
  background: ${props => props.color || 'blue'};
  width: 140px;
  align-items: center;
  overflow: hidden;
  border-radius: 2px;
  margin: 16px 8px;
  transition: background .15s ease-in;
  cursor: pointer;
  text-decoration: none;
  
  &:hover {
    background: #555;
  }
`;

const SocialLinkIconContainer = styled.div`
  width: 36px;
  min-width: 36px;
  height: 36px;
  padding: 4px 8px;
  box-sizing: border-box;
  position: relative;
  background: #333;
  display: flex;
  align-items: center;
  
  &:after {
    content: "";
    border-left: solid 8px #333;
    border-top: solid 8px transparent;
    border-right: none;
    border-bottom: solid 8px transparent;
    position: absolute;
    right: -8px;    
  }
`;
const SocialLinkIcon = styled.img`
  width: 100%;  
`;

const SocialLinkText = styled.span`
  color: #ffffff;
  padding: 4px 8px;
  text-align: center;
  width: 100%;
  font-size: 12px;
`;

class App extends Component {
  render(){
    return (
      <AppContainer>
        <Wallpaper/>
        <ContentContainer>
          <SocialInformationContainer>
            <Owner>
              <Avatar>
                <img
                  src={avatar}
                  alt="Sergei Zelinsky"
                />
              </Avatar>
              <Name>
                Sergei Zelinsky
              </Name>
            </Owner>

            <SocialLinksContainer>
              {
                SOCIAL_LINKS.map(socialLink => (
                  <SocialLink
                    href={socialLink.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    color={socialLink.color}
                    key={socialLink.name}
                  >
                    <SocialLinkIconContainer>
                      <SocialLinkIcon
                        src={socialLink.imageURL}
                      />
                    </SocialLinkIconContainer>
                    <SocialLinkText>
                      {socialLink.name}
                    </SocialLinkText>
                  </SocialLink>
                ))
              }
            </SocialLinksContainer>
          </SocialInformationContainer>
        </ContentContainer>
      </AppContainer>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.js